import { Fare } from '@silbo/core';
import { useAuthenticationContext } from '../../../contexts/AuthenticationContext';

export const useAssignation = (fare: Fare) => {
  const { user } = useAuthenticationContext();

  const assignation = fare.assignations?.find((a) => a.porter.id === user?.porter?.id);

  return { assignation };
};
